import baseApi from "./baseApi";
import axios from "axios";


const getSites = () => axios.get("Statistician/SiteList", { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const getStatisticaian = (key,metrics,dimensions,startDate,endDate) => axios.get("/Statistician/"+key+"/"+metrics+"/"+dimensions+"/"+startDate+"/"+endDate);

export default {
    getStatisticaian,
    getSites
};